import React, { forwardRef } from 'react'
import './style/scroll.scss'

export const Scroll = forwardRef((
    props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 
    ref: React.LegacyRef<HTMLDivElement>) => {
    return (
        <div {...props} className={`custom-scroll ${props.className}`} ref={ref}>
            { props.children }
        </div>
    )
})

Scroll.displayName = 'Scroll'
